module.exports = __webpack_public_path__ + "img/agent.ea27bfac.svg";